export const formatCurrencyShort = (value) => {
  const abs = Math.abs(value);

  if (abs >= 1000) {
    return `A$${(value / 1000).toFixed(1)}K`;
  }

  return `A$${value.toLocaleString("en-AU", { maximumFractionDigits: 2 })}`;
};
